import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useEventDivisionsScoreboard } from "../util/db";
import Spinner from "react-bootstrap/Spinner";
import FormAlert from "./FormAlert";
import React from "react";
import ScoreboardDivisionSection from "./ScoreboardDivisionSection";

import "./ScorecardSummaryTableSticky.css"; // Import the CSS file

function DisplayScoreboardByDivision(props) {
  const eventId = props.eventId;
  const throwScoringModeId = props.throwScoringModeId;

  // get event divisions
  const {
    data: eventDivisions,
    status: eventDivisionsStatus,
    error: eventDivisionsError,
  } = useEventDivisionsScoreboard(eventId);

  // Create division array from eventDivisions
  const divisionArray = [];
  if (eventDivisions) {
    eventDivisions.forEach((division) => {
      divisionArray.push([
        division.event_divisions_id,
        division.divisions.name,
      ]);
    });
  }
  return (
    <>
      <Row>
        <Col>
          {eventDivisionsStatus === "loading" && (
            <div className="py-5 px-3 align-self-center">
              <Spinner animation="border" variant="primary" />
              <span className="ms-2">Loading divisions...</span>
            </div>
          )}

          {eventDivisionsStatus === "error" && (
            <div className="py-5 px-3 align-self-center">
              <FormAlert
                type="error"
                message={
                  eventDivisionsError?.message || "Error loading divisions"
                }
              />
            </div>
          )}

          {eventDivisionsStatus === "success" && divisionArray.length === 0 && (
            <div className="py-5 px-3 align-self-center">
              No divisions found for this event.
            </div>
          )}

          {eventDivisionsStatus === "success" && divisionArray.length > 0 && (
            <>
              {divisionArray.map((division, index) => (
                <ScoreboardDivisionSection
                  key={index}
                  division={division}
                  index={index}
                  throwScoringModeId={throwScoringModeId}
                  eventId={eventId}
                />
              ))}
              <br />
            </>
          )}
        </Col>
      </Row>
    </>
  );
}

export default DisplayScoreboardByDivision;
